export default __webpack_public_path__ + "static/media/app-promo.ba86aeea.png";